<div class="footer-links d-flex justify-content-center">
  <span l10nTranslate>Footer.Message</span><span>&nbsp;</span><a href="mailto:SamplicityProductSupport@Caretria.com" target="_blank">SamplicityProductSupport@Caretria.com</a>  
</div>
